module.exports = __webpack_public_path__ + "static/img/6.ff77efe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/6.png
// module id = 0DhX
// module chunks = 1